export function FullScreenListener() {
  // no-op on non-Electron
  return null;
}
